import { useContext } from 'react';
import { AuthContext } from 'softcat:contexts/auth.tsx';

export const useAuth = () => {
    const authContext = useContext(AuthContext);

    if (!authContext) {
        throw new Error('AuthContext has to be used within <AuthProvider>');
    }

    return authContext;
};
